export default __webpack_public_path__ + "static/media/antilla-logo.f7be30f6.png";